import { memoryStore, useStore } from "../../../lib/store";

// What the user did to their profile picture while editing it or requesting the
// Lemon-certified label — held outside the (effect-free) sheet views. Shared
// because only one avatar-picking view is ever open in the sheet at a time.
// `removed` is the explicit "drop my photo, fall back to a default avatar"
// intent — distinct from `untouched`, which must NOT clear anything on save.
export type AvatarPick =
  | { status: "untouched" }
  | { status: "picked"; dataUrl: string }
  | { status: "removed" };

const store = memoryStore<AvatarPick>({ status: "untouched" });

export function useAvatarPicker(): AvatarPick {
  const [state] = useStore(store);
  return state;
}

export function setPickedAvatar(dataUrl: string): void {
  store.set({ status: "picked", dataUrl });
}

export function setRemovedAvatar(): void {
  store.set({ status: "removed" });
}

export function resetAvatarPicker(): void {
  store.set({ status: "untouched" });
}
